      <div class="pin-container">
             
              <div class="step-container flex justify-space-between">
                <!-- step-1 -->
                <span class="step-val "  [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step1Active || rootScope.activeCustTab.pinEntryApp?.step1Complete }">
                  <span class="step-circle "
                    [ngClass]="rootScope.activeCustTab.pinEntryApp?.step1Active? 'active' : 'complete'">
                    <span *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Complete"> <i
                        class="fa-solid fa-check"></i></span>
                    <span class="step-no" *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active">1</span>
                  </span>Go to ALIS</span>
                <!-- step-2 -->
                <span class="step-val" [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step2Active || rootScope.activeCustTab.pinEntryApp?.step2Complete }">
                  <span class="step-circle"
                    [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step2Active,'complete': rootScope.activeCustTab.pinEntryApp?.step2Complete }">
                    <span *ngIf="rootScope.activeCustTab.pinEntryApp?.step2Complete"> <i
                        class="fa-solid fa-check"></i></span>
                    <span class="step-no" *ngIf="!rootScope.activeCustTab.pinEntryApp?.step2Complete">2</span>
                  </span>Transfer the call</span>
                <!-- step-3 -->
                <span class="step-val" [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step3Active || rootScope.activeCustTab.pinEntryApp?.step3Complete }">
                  <span class="step-circle"
                    [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step3Active,'complete': rootScope.activeCustTab.pinEntryApp?.step3Complete }">
                    <span *ngIf="rootScope.activeCustTab.pinEntryApp?.step3Complete"> <i
                        class="fa-solid fa-check"></i></span>
                    <span class="step-no" *ngIf="!rootScope.activeCustTab.pinEntryApp?.step3Complete">3</span>
                  </span>Resume conversation</span>
              </div>
              <!-- For step-1 content  -- Pin Entry without language selection -->
              <p class="steps-content step1-content"
                *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active && !(languages?.length > 1)">
                Go to ALIS to transfer the customer to the PIN Entry App.
              </p>
              <!-- For step-1 content -- Pin Entry with language selection -->
              <p class="steps-content step1-content"
                *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active && languages?.length > 1">
                Select the language for the PIN Entry App. Then, press the PIN Entry button and go to ALIS to transfer the customer to PIN Entry App.
              </p>
              <mat-radio-group *ngIf="languages?.length > 1 && rootScope.activeCustTab.pinEntryApp?.step1Active"
                color="primary" class="account-selection" disableRipple aria-label="Select an option"
                [(ngModel)]="this.rootScope.activeCustTab.selectedAlisLang " (change)="onRadioChange($event.value)">
                <mat-radio-button class="delivery-method-button" *ngFor="let language of languages"
                  [value]="language.code">
                  {{language.label}}
                </mat-radio-button>
              </mat-radio-group>

              <!-- For step-2 content -->
              <p class="pin-content step2-content hide1" *ngIf="rootScope.activeCustTab.pinEntryApp?.step2Active">
                The customer will be transferred to ALIS and enter their PIN.
              </p>
              <!-- For step-3 content -->
              <p class="pin-content step3-content hide1" *ngIf="rootScope.activeCustTab.pinEntryApp?.step3Active">
                After the transfer is complete, the customer will return to the Care Portal.
              </p>
              <div class="btn-refresh-container flex">
                <div class="btn-controls">
                  <f-button text="PIN Entry" title="PIN Entry" [disabled]="!rootScope.isLiveCall && rootScope.activeCustTab.CS_SECURITY_LEVEL=='4'"
                    *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active" type="button"
                    (buttonClicked)="pinEntryAttrUpdate()" variant="progressive" class=""></f-button>
                  <f-button text="Cancel" title="Cancel" (buttonClicked)="cancelButton()"
                    *ngIf="rootScope.activeCustTab.pinEntryApp?.step2Active"
                    [disabled]="rootScope.activeCustTab.pinEntryApp?.step3Active" type="button" variant="action"
                    class="hide1"></f-button>
                </div>
                <!-- Enable to show refresh message  -->
                <div class="refresh-link " *ngIf="rootScope.activeCustTab.pinEntryApp?.step3Active">
                  <p> If the Security Level didn’t update as expected, click <button class="btn-alert"  (click)="genesysCloudService.getLiveCallStatusForAuthMethod()">Refresh</button></p>
                </div>
              </div>
              
            </div>